import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import ServicePlaceholder from './components/ServicePlaceholder';
import PanelFastFood from './modulos/fast-food/PanelFastFood';
import Inventario from './modulos/fast-food/Inventario';
import Bodega from './modulos/fast-food/Bodega';
import Mezclas from './modulos/fast-food/Mezclas';
import Ordenes from './modulos/fast-food/Ordenes';
import Clientes from './modulos/fast-food/Clientes';
import Reportes from './modulos/fast-food/Reportes';
import PuntosVenta from './modulos/fast-food/PuntosVenta';
import TasaDeCambio from './modulos/fast-food/TasaDeCambio';
import PanelCaja from './modulos/fast-food/Caja/PanelCaja';
import Impresoras from './modulos/fast-food/Impresoras';
import Promociones from './modulos/fast-food/Promociones';
import Gastos from './modulos/fast-food/Gastos';
import Toppings from './modulos/fast-food/Toppings';
import Variables from './modulos/fast-food/Variables';
import ReportesPeriodicos from './modulos/fast-food/ReportesPeriodicos';
import FacturacionSRI from './modulos/fast-food/FacturacionSRI';
import PanelCobranzas from './modulos/cobranzas/PanelCobranzas';
import ConfiguracionSecuencia from './modulos/fast-food/ConfiguracionSecuencia';
import Mesas from './modulos/fast-food/Mesas';
import logo from './assets/logo.png';
import './App.css';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const FastFoodRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Componente para proteger la ruta de Cobranzas (Solo GESTOR_COBRANZAS)
const GestorCobranzasRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user?.role_details?.name !== 'GESTOR_COBRANZAS') {
    return <Navigate to="/fast-food/pos" />;
  }

  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName === 'GESTOR_COBRANZAS') {
      return <Navigate to="/cobranzas" />;
  }

  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/fast-food/pos" />;
  }

  const quickLinks = [
    { to: '/fast-food/pos', icon: 'bi-basket2', title: 'Punto de Venta', text: 'Tomar pedidos y cobrar' },
    { to: '/fast-food/orders', icon: 'bi-receipt', title: 'Órdenes', text: 'Seguimiento y cocina' },
    { to: '/fast-food/shift', icon: 'bi-cash-coin', title: 'Caja', text: 'Turnos y arqueos' },
    { to: '/fast-food/inventory', icon: 'bi-journal-text', title: 'Menú', text: 'Productos y precios' },
    { to: '/fast-food/reports', icon: 'bi-graph-up', title: 'Reportes', text: 'Ventas y desempeño' },
    { to: '/users', icon: 'bi-people', title: 'Usuarios', text: 'Equipo y accesos' },
  ];
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Buenos días' : hour < 19 ? 'Buenas tardes' : 'Buenas noches';

  return (
  <div className="saio-home">
    <style>{`
      .saio-home { max-width: 1100px; margin: 0 auto; padding: 1.5rem 0 3rem; }
      .saio-home__hero {
        display: flex; align-items: center; gap: 2rem;
        padding: 2.5rem 2.75rem; border-radius: 12px;
        background: linear-gradient(135deg, #f2ede4 0%, #faf7f1 100%);
        border: 1px solid var(--border-color);
        position: relative; overflow: hidden;
      }
      .saio-home__hero::after {
        content: ''; position: absolute; right: -80px; top: -80px; width: 320px; height: 320px;
        border-radius: 50%; border: 1px solid rgba(201,151,58,0.25); pointer-events: none;
      }
      .saio-home__hero::before {
        content: ''; position: absolute; right: -30px; top: -30px; width: 220px; height: 220px;
        border-radius: 50%; border: 1px solid rgba(201,151,58,0.18); pointer-events: none;
      }
      .saio-home__logo { width: 112px; height: 112px; border-radius: 50%; flex-shrink: 0; box-shadow: 0 18px 40px -18px rgba(74,50,34,0.5); }
      .saio-home__eyebrow { font-size: 0.68rem; letter-spacing: 0.3em; text-transform: uppercase; color: var(--amber); margin: 0 0 0.5rem; }
      .saio-home__title { font-size: 2rem; font-weight: 700; color: var(--wood-deep); margin: 0 0 0.4rem; line-height: 1.1; }
      .saio-home__sub { color: var(--stone-500); margin: 0; font-size: 1rem; }
      .saio-home__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(230px, 1fr)); gap: 1rem; margin-top: 1.5rem; }
      .saio-home__card {
        display: flex; align-items: center; gap: 1rem; padding: 1.1rem 1.25rem;
        background: #fff; border: 1px solid var(--border-color); border-radius: 10px;
        color: inherit; text-decoration: none;
        transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
      }
      .saio-home__card:hover { border-color: var(--amber); box-shadow: var(--shadow-md); transform: translateY(-2px); color: inherit; }
      .saio-home__icon {
        width: 44px; height: 44px; border-radius: 10px; flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        background: var(--stone-100); color: var(--wood); font-size: 1.2rem;
      }
      .saio-home__card-title { font-weight: 500; color: var(--wood-deep); }
      .saio-home__card-text { font-size: 0.8rem; color: var(--stone-500); margin-top: 1px; }
      @media (max-width: 640px) { .saio-home__hero { flex-direction: column; text-align: center; padding: 2rem 1.5rem; } }
    `}</style>

    <section className="saio-home__hero">
      <img src={logo} alt="SAIO SUSHI" className="saio-home__logo" />
      <div>
        <p className="saio-home__eyebrow">Puré sushi experience</p>
        <h1 className="saio-home__title">{greeting}, {user?.first_name || user?.username || 'bienvenido'}.</h1>
        <p className="saio-home__sub">Selecciona un módulo para comenzar a administrar SAIO SUSHI.</p>
      </div>
    </section>

    <div className="saio-home__grid">
      {quickLinks.map((q) => (
        <Link key={q.to} to={q.to} className="saio-home__card">
          <div className="saio-home__icon"><i className={`bi ${q.icon}`}></i></div>
          <div>
            <div className="saio-home__card-title">{q.title}</div>
            <div className="saio-home__card-text">{q.text}</div>
          </div>
        </Link>
      ))}
    </div>
  </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de creación/edición eliminadas porque ahora son Modales */}

          <Route path="/fast-food" element={
            <FastFoodRoute>
              <PanelFastFood />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/inventory" element={
            <FastFoodRoute>
              <Inventario />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/toppings" element={
            <FastFoodRoute>
              <Toppings />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/variables" element={
            <FastFoodRoute>
              <Variables />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/promotions" element={
            <FastFoodRoute>
              <Promociones />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/bodega" element={
            <FastFoodRoute>
              <Bodega />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mezclas" element={
            <FastFoodRoute>
              <Mezclas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/orders" element={
            <FastFoodRoute>
              <Ordenes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/customers" element={
            <FastFoodRoute>
              <Clientes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/reports" element={
            <FastFoodRoute>
              <Reportes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/periodic-reports" element={
            <FastFoodRoute>
              <ReportesPeriodicos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/pos" element={
            <FastFoodRoute>
              <PuntosVenta />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tasa-cambio" element={
            <FastFoodRoute>
              <TasaDeCambio />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/shift" element={
            <FastFoodRoute>
              <PanelCaja />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/feria-shift" element={
            <FastFoodRoute>
              <PanelCaja isFeriaMode={true} />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/gastos" element={
            <FastFoodRoute>
              <Gastos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/facturacion-sri" element={
            <FastFoodRoute>
              <FacturacionSRI />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/printers" element={
            <FastFoodRoute>
              <Impresoras />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/secuencia" element={
            <FastFoodRoute>
              <ConfiguracionSecuencia />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tables" element={
            <FastFoodRoute>
              <Mesas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mesas" element={
            <FastFoodRoute>
              <Mesas />
            </FastFoodRoute>
          } />


          <Route path="/cobranzas" element={
            <GestorCobranzasRoute>
              <PanelCobranzas />
            </GestorCobranzasRoute>
          } />

          <Route path="/hotel" element={
            <PrivateRoute>
              <ServicePlaceholder title="Hotel" />
            </PrivateRoute>
          } />

          <Route path="/pool" element={
            <PrivateRoute>
              <ServicePlaceholder title="Piscinas" />
            </PrivateRoute>
          } />

          <Route path="/restaurant" element={
            <PrivateRoute>
              <ServicePlaceholder title="Restaurante" />
            </PrivateRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
